import { Log, Level, Logger } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import Moment from 'moment';
import * as Actions from '../constants/helpdesk';
import { IHelpdeskCreateGetAction, IHelpdeskSetAction, IHelpdeskMessageSetAction } from '../../models/action/helpdesk';
import { actions } from 'react-choices';

const _logger = Log.create('HelpDesk Reducer');

const helpDeskReducer = (state = GlobalState().helpDesk, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.actions.SET_HELPDESK_LIST) {
        const helpDeskAction = action as IHelpdeskSetAction;
        newState.helpDeskList = helpDeskAction.helpDeskList;
        newState.helpDeskListPage = helpDeskAction.page;
        newState.helpDeskListTake = helpDeskAction.take;
        newState.helpDeskListTotalCount = helpDeskAction.totalCount;
        newState.categories = helpDeskAction.helpDeskList;
        newState.helpDeskListItem = helpDeskAction.helpDeskList;
    } else if (action.type === Actions.actions.SET_HELPDESK_MESSAGE) {
        const helpDeskChatAction = action as IHelpdeskMessageSetAction;
        newState.helpDeskChat = helpDeskChatAction.helpDeskChat;
    } else {
        return state;
    }
    return Object.assign({}, state, newState);
};

export default helpDeskReducer;
